/* eslint-disable max-len */
import { CompanyAPI } from '@api';

const rejectInstallmentAnticipation = async (id) => {
  const params = {
    lending_id: id,
    accepted: false,
  };

  return CompanyAPI.acceptOrRejectInstallmentAnticipation(params)
    .then(({ data }) => data)
    .catch((error) => Promise.reject(error.response));
};

export { rejectInstallmentAnticipation };
